import {removeTagsFromText} from '../../branding/emailSubjectTextEditor/EmailSubjectTextEditor';
import {replaceBracketPlaceholdersWithValues} from '../../../component/textEditor/Variables.js';

type TranslateVariable = (key: string) => string;

/** Snippet for closed step header: strip HTML, resolve [snake_case] placeholders, trim. */
export function getPreviewText(
    html: string | undefined,
    variables: Record<string, unknown>,
    translateVariable: TranslateVariable,
    maxLength = 50
): string {
    if(!html) return '';
    const plain = removeTagsFromText(html);
    return replaceBracketPlaceholdersWithValues(plain, variables, translateVariable).substring(0, maxLength);
}
